import { getSortedFormFields } from '@utils/forms';
import { DEFAULT_COUNTRY, getCountryByPhone } from '@services/phoneNumberService';
import { helpWithOptions, computeOpsManagementOrdersOptions, computeOpsManagementOptions, dataServicesOptions, arubaCentralOptions } from './OSQBMSupportFormOptions';
import { BUSINESS_REGIONS_TYPES, BUSINESS_REGIONS } from '@constants/regions';

const getArubaNamespace = (countryCode: string, phoneNumber: string): string => {
  const phone: string = countryCode + phoneNumber;
  const country: string = getCountryByPhone(phone);

  const businessRegion: string = BUSINESS_REGIONS[country] || BUSINESS_REGIONS[DEFAULT_COUNTRY];
  let namespace: string;

  switch (businessRegion) {
    case BUSINESS_REGIONS_TYPES.emea:
      namespace = 'hpe_bil_met_sub_aruba_emea';
      break;
    case BUSINESS_REGIONS_TYPES.americas:
      namespace = 'hpe_bil_met_sub_aruba_americas';
      break;
    case BUSINESS_REGIONS_TYPES.asipacific:
      namespace = 'hpe_bil_met_sub_aruba_asiapacific';
      break;
    default:
      namespace = 'hpe_bil_met_sub_aruba_americas';
  }

  return namespace;
};

export const getOSQBMSupportFormData = (target, application, helpWithSecondary, helpWithThird, countryCode, phone) => {
  let namespace: string;
  const subject: string = `Quote Billing : ${application}, ${helpWithSecondary}, {formId}`;

  switch (application) {
    case helpWithOptions.arubaCentral:
      namespace = helpWithSecondary === arubaCentralOptions.subscription ? 'hpe_greenlake_user' : getArubaNamespace(countryCode as string, phone as string);
      break;
    case helpWithOptions.computeOpsManagement:
      namespace = (helpWithThird === computeOpsManagementOrdersOptions.newSubscriptionOrder || helpWithSecondary === computeOpsManagementOptions.subscriptions)
        ? 'hpe_bil_met_new_sub'
        : 'hpe_bil_met_sub';
      break;
    case helpWithOptions.dataServices:
      switch (helpWithSecondary) {
        case dataServicesOptions.subscriptions:
          namespace = 'hpe_greenlake_user';
          break;
        case dataServicesOptions.metering:
          namespace = 'hpe_bil_met_sub_gl';
          break;
        default:
          namespace = 'hpe_bil_met_sub';
          break;
      }
      break;
    case helpWithOptions.hpeGreenLakeFlex:
      namespace = 'hpe_bil_met_sub_gl';
      break;
    case helpWithOptions.hpeGreenLakePlatform:
      namespace = 'hpe_devportal_glcentral';
      break;
    default:
      namespace = 'hpe_bil_met_sub';
  }

  return getSortedFormFields(target, namespace, subject);
};
